export default __webpack_public_path__ + "static/media/distribution-warehouse-building-interior-large-storage-area-with-goods-shelf.c817e99f.jpg";